<template>
    <div class="home_ld_box">
        <HeaderNav
            header-title="运营报表"
            :left-icon-name="iosIconNum"
            right-icon-name="3"
        ></HeaderNav>
        <div class="home-content-box">
            <div class="header-box">
                <img src="../../assets/images/homeLd/banner.png" alt="">
            </div>
            <div class="home-content">
                <template v-for="(item, index) in homeData">
                    {{ item.class }}
                    <div @click="homeLink(item.code)" :class="item.css" :key="index">
                        <p>{{ item.name }}</p>
                    </div>
                </template>
            </div>
        </div>
    </div>
</template>

<script>
import { HeaderNav } from '@/components/';
export default {
    data() {
        return {
            homeData: [],
            selectTimeYear: this.timeFormat(new Date(), 'year'),
            selectTimeMonth: this.timeFormat(new Date(), 'month', 'upMonth'),
            iosIconNum: 2,
        };
    },
    components: {
        HeaderNav,
    },
    mounted() {
        localStorage.setItem('objTimeYear', '');
        localStorage.setItem('objTimeMonth', '');
        this.selectTimeYear = 2019;
        this.selectTimeMonth = 12;
        this.homeInit();
        // if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) {
        //     this.iosIconNum = 3;
        // }
    },
    methods: {
        homeLink(link) {
            this.$router.isBack = 2;
            this.$router.push({ name: link,
                query: {
                    year: this.selectTimeYear,
                    month: this.selectTimeMonth,
                },
            });
        },
        // 格式化日期
        timeFormat(date, status, upMonth) {
            const y = date.getFullYear(); // 年
            let m = date.getMonth() + 1; // 月
            let d = date.getDate(); // 日
            m = m > 9 ? m : '0' + m;
            d = d > 9 ? d : '0' + d;
            if (status === 'year') {
                return y;
            } if (status === 'month') {
                if (upMonth === 'upMonth') {
                    return m - 1;
                }
                return m;

            } if (status === 'day') {
                return d;
            }
            return `${y}-${m}-${d}`;
        },
        homeInit() {
            this.$axios
                .get('/interfaceApi/basicplatform/usermenu?code=concrete_app')
                .then(res => {
                    this.homeData = res.userMenus[0].children;
                })
                .catch(error => {
                    this.$message.error(error.ErrorCode.Message);
                });
        },
    },
};

</script>
<style lang='stylus'>
.home-content-box
    height 100%
    padding-top 44rpx
    overflow hidden
.header-box
    width 100%
    img
        width 100%
        height 100%
.home-content
    padding 17rpx
    height 100%
    background url('../../assets/images/homeLd/bg.png')
    background-repeat no-repeat
    background-size 100% 100%
    background-color #124181
    margin-top -5rpx
    div
        width 105rpx
        height 105rpx
        background-repeat no-repeat
        background-size 100%
        float left
        margin-right 12rpx
        margin-bottom 10rpx
        display flex
        justify-content center
        align-items flex-end
        p
            color #FD8C48
            margin-bottom 10rpx
            font-size 12rpx
        &:nth-child(3n)
            margin-right 0
        &:nth-child(odd) p
            color #29A1FE
.cxgk_class
    background url('../../assets/images/homeLd/cxqk.png')
.cplx_class
    background url('../../assets/images/homeLd/cplx.png')
.hkqk_class
    background url('../../assets/images/homeLd/hkqk.png')
.zcsy_class
    background url('../../assets/images/homeLd/zcsy.png')
.wzcg_class
    background url('../../assets/images/homeLd/wzcg.png')
.kcqk_class
    background url('../../assets/images/homeLd/kcqk.png')
.yfqk_class
    background url('../../assets/images/homeLd/yfqk.png')
.sccb_class
    background url('../../assets/images/homeLd/sccb.png')
.jsc_class
    background url('../../assets/images/homeLd/jsc.png')
</style>
